import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';

import {
  type AcceptSuggestionAction,
  type FieldSuggestion,
  type RejectSuggestionAction,
  type UpdateSuggestionAction,
} from 'hb-react/shared/components/AIFormWidget/types';

import { RefineSuggestionForm } from '../RefineSuggestionForm';

interface ActionsProps {
  acceptSuggestion: AcceptSuggestionAction;
  rejectSuggestion: RejectSuggestionAction;
  suggestion: FieldSuggestion;
  updateSuggestion: UpdateSuggestionAction;
}

export const Actions = ({
  suggestion,
  acceptSuggestion,
  rejectSuggestion,
  updateSuggestion,
}: ActionsProps) => {
  if (suggestion.status === 'refining') {
    return (
      <RefineSuggestionForm
        initialSuggestion={suggestion}
        updateSuggestion={updateSuggestion}
      />
    );
  }

  if (suggestion.status === 'pending') {
    return (
      <Box display="flex" style={{ gap: '8px' }}>
        <>
          <Button
            variant="primary"
            size="small"
            onClick={() => acceptSuggestion(suggestion)}
          >
            {s__('AIForm|Accept')}
          </Button>
          <Button
            onClick={() =>
              updateSuggestion({
                id: suggestion.id,
                status: 'refining',
              })
            }
            icon={() => (
              <FontAwesomeIcon
                iconName="sparkles"
                iconType={CATEGORIES.SOLID}
                height="16px"
              />
            )}
          >
            {s__('AIForm|Refine')}
          </Button>
          <Button
            variant="secondary"
            size="small"
            onClick={() => rejectSuggestion(suggestion.id)}
          >
            {s__('AIForm|Reject')}
          </Button>
        </>
      </Box>
    );
  }

  if (suggestion.status === 'rejected') {
    return (
      <Box px={2} py={1} bg="lightGrey" style={{ borderRadius: '4px' }}>
        {s__('AIForm|Rejected')}
      </Box>
    );
  }

  return null;
};
